<template>
  <div v-if="value">
    <template v-for="(item, index) in value.items">
      <Insurance
        :key="index"
        :index="index"
        v-model="value.items[index]"
        :protocol="protocol"
        @delete-insurance="deleteInsurance"
      />
    </template>
    <div class="text-center">
      <v-btn color="success" large @click="addInsurance" class="mb-4 mt-2">Legg til forsikring</v-btn>
    </div>
  </div>
</template>

<script>
import Insurance from "./Insurance";
export default {
  props: ["value", "protocol"],
  components: { Insurance },
  data() {
    return {};
  },
  methods: {
    addInsurance() {
      this.value.items.push(
        {
          company: "",
          taker: "",
          date: "",
          person: "",
          name: "",
          responsibility: ""
        }
      );
    },
    deleteInsurance(i) {
      this.value.items.splice(i, 1);
    }
  }
};
</script>